<div class="dialog-header">
  <div class="dialog-title">
    <h1>
      {{
        id ? ("editDonation" | translate) : ("newDonation" | translate)
      }}
    </h1>
  </div>

  <a href="javascript:;" class="dialog-close" (click)="close()"
    ><i class="fal fa-times"></i
  ></a>
</div>

<div class="dialog-content">
  <nz-spin [nzSpinning]="isLoading">
    <form nz-form nzLayout="vertical" [formGroup]="form" (submit)="save()">
      <!-- <nz-form-item>
        <nz-form-label nzFor="name" nzRequired>{{
          "Naziv" | translate
        }}</nz-form-label>
        <nz-form-control>
          <input
            nz-input
            formControlName="name"
            id="name"
            [placeholder]="'name' | translate"
          />
        </nz-form-control>
      </nz-form-item> -->

      <nz-form-item>
        <nz-form-label nzFor="categoryId" nzRequired>{{
          "category" | translate
        }}</nz-form-label>
        <nz-form-control >
          <nz-select formControlName="categoryId">
            <nz-option *ngFor="let data of dataCategories"
              [nzValue]="data.id"
              [nzLabel]="data.name"
            ></nz-option>         
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="donationDate" nzRequired>{{
          "date" | translate
        }}</nz-form-label>
        <nz-form-control>
          <nz-date-picker
            formControlName="donationDate"
            id="donationDate"
            [nzPlaceHolder]="'date' | translate"
          ></nz-date-picker>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="note">Opis</nz-form-label>
        <nz-form-control>
          <textarea
            rows="4"
            nz-input
            formControlName="note"
            id="note"
            [placeholder]="'note' | translate"
          ></textarea>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="familyId" nzRequired>{{
          "family" | translate
        }}</nz-form-label>
        <nz-form-control >
          <nz-select formControlName="familyId">
            <nz-option *ngFor="let data of dataFamilies"
              [nzValue]="data.id"
              [nzLabel]="data.representative"
            ></nz-option>         
          </nz-select>
        </nz-form-control>
      </nz-form-item>


      <div class="mt-4">
        <button nz-button nzType="primary" type="submit" [nzLoading]="isSaving">
          {{ id ? ("saveChanges" | translate) : ("add" | translate) }}
        </button>
        <button
          nz-button
          (click)="close()"
          type="button"
          class="ml-2"
          [disabled]="isSaving"
        >
          {{ "cancel" | translate }}
        </button>
      </div>
    </form>
  </nz-spin>
</div>
